import * as yup from "yup";

// Reusable primitives
const nameField = yup
  .string()
  .trim()
  .min(2, "Please enter your full name")
  .max(100, "Name is too long")
  .required("Name is required");

const emailField = yup
  .string()
  .trim()
  .email("Please enter a valid email address")
  .required("Email is required");

const messageField = yup
  .string()
  .trim()
  .min(10, "Please enter at least 10 characters")
  .max(2000, "Message is too long")
  .required("Please enter your message");

export const basicSchema = yup.object({
  name: nameField,
  email: emailField,
  message: messageField,
});

export const subscriptionSchema = yup.object({
  name: nameField,
  email: emailField,
});

// Backward-compat alias (keeps old imports working)
export { subscriptionSchema as subsciptionSchema };
